var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitPoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    fill: "#33BB33"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.01 18.255C24.615 18.255 23.475 17.1 23.475 15.705C23.475 15.0327 23.7421 14.3879 24.2175 13.9125C24.6929 13.4371 25.3377 13.17 26.01 13.17C27.42 13.17 28.56 14.31 28.56 15.705C28.56 17.1 27.42 18.255 26.01 18.255ZM21.45 35.895L12.555 34.125L13.065 31.575L19.29 32.85L21.315 22.56L19.035 23.46V27.75H16.5V21.81L23.1 19.005L24.105 18.885C25.005 18.885 25.755 19.395 26.25 20.16L27.54 22.185C28.56 24 30.585 25.23 33 25.23V27.75C30.21 27.75 27.66 26.505 26.01 24.6L25.26 28.41L27.915 30.945V40.5H25.38V32.85L22.71 30.315L21.45 35.895ZM37.5 40.5H34.5V10.5H15V30.165L12 29.535V7.5H37.5V40.5ZM15 40.5H12V35.67L15 36.3V40.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitPoi);
export default __webpack_public_path__ + "static/media/exit-poi.15ca4106f8076286af53628966a3e949.svg";
export { ForwardRef as ReactComponent };